import * as PIXI from 'pixi.js'

export const DBL_CLICK_TIME = 300
export const MAX_CLICK_DELTA = 2

/**
 * Event handlers
 *
 * @type {string[]}
 */
export const EventHandlers = {
  onAdded: 'added',
  onRemoved: 'removed',
  onClick: 'click',
  onDoubleClick: 'doubleclick',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onMouseUpOutside: 'mouseupoutside',
  onPointerCancel: 'pointercancel',
  onPointerDown: 'pointerdown',
  onPointerMove: 'pointermove',
  onPointerOut: 'pointerout',
  onPointerOver: 'pointerover',
  onPointerTap: 'pointertap',
  onPointerUp: 'pointerup',
  onPointerUpOutside: 'pointerupoutside',
  onRightClick: 'rightclick',
  onRightDown: 'rightdown',
  onRightUp: 'rightup',
  onRightUpOutside: 'rightupoutside',
  onTap: 'tap',
  onTouchCancel: 'touchcancel',
  onTouchEnd: 'touchend',
  onTouchEndOutside: 'touchendoutside',
  onTouchMove: 'touchmove',
  onTouchStart: 'touchstart',
}

// EVENTS -----------------------------------------------------------------------------

PIXI.DisplayObject.prototype.addEventListener = function (evt, fn, context) {
  if (evt === 'click' || evt === 'doubleclick') {
    const noClickHandlers = this.listeners('$click').length === 0
    const noDoubleClickHandlers = this.listeners('$doubleclick').length === 0
    if (noClickHandlers && noDoubleClickHandlers) {
      const handler = function (e) {
        if (e.drag) {
          return
        }

        if (e.data.mouseDragDelta > MAX_CLICK_DELTA) {
          return
        }

        // Double Click
        if (this.listeners('$doubleclick', true)) {
          const clickInterval = Date.now() - (this.$lastClickTime || 0)
          if (clickInterval < DBL_CLICK_TIME) {
            // Preventing selection
            const { originalEvent } = e.data
            originalEvent.preventDefault && originalEvent.preventDefault()
            return this.emit('$doubleclick', e)
          }
        }

        this.$lastClickTime = Date.now()
        this.emit('$click', e)
      }

      this.on('click', handler, context)
    }

    return this.on(`$${evt}`, fn, context)
  }

  this.on(evt, fn, context)
}

PIXI.DisplayObject.prototype.removeEventListener = function (evt, fn, context) {
  if (evt === 'click' || evt === 'doubleclick') {
    this.removeListener(`$${evt}`, fn, context)

    if (!this.listeners('$click', true) && !this.listeners('$doubleclick', true)) {
      this.removeAllListeners('click')
    }

    return
  }

  this.removeListener(evt, fn, context)
}
